<template>

  <splitpanes class="default-theme">

    <!-- 左侧目录结构 -->
    <pane min-size="10" size="20" max-size="30" style="height: 100%;" >
      <el-tree :data="dirData" :props="defaultProps" node-key="id" style="width: 100%;height: 100%"
               @node-click="nodeClickHandle"
               default-expand-all highlight-current
               :expand-on-click-node="false" class="mytree" ref="tree">

        <template #default="{ node, data }">
          <el-row style="width:100%;line-height: 32px" :gutter="0">
            {{ data.name }}
            <div v-if="currentDir.id == data.id" style="position: absolute;right: 0">
              <FrameButton v-if="data.level < 7" :key="data.id" :button="addButton" :parentData="data"></FrameButton>
              <FrameButton :key="data.id" :button="editButton" :parentData="data"></FrameButton>
            </div>
          </el-row>
        </template>

      </el-tree>
    </pane>

    <pane min-size="30">
      <el-card class="box-card">
        <template #header>
          <div class="card-header">
            <span width="100%" class="department-name">当前目录：{{ currentDir.path }}</span>
          </div>
        </template>
        <div>
          <frame-query
              ref="frameQuery"
              componentParam="sys_frame_json"
              :parent-data="queryParam"
          ></frame-query>
        </div>
      </el-card>
    </pane>

  </splitpanes>

</template>

<script>

import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

export default {
  name: "User",
  components: {Splitpanes, Pane},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    }
  },
  computed: {
    queryParam() {
      return {
        dir_id: this.currentDir.id
      }
    }
  },
  provide() {
    return {
      $fn: {
        reloadTreeData: () => {
          this.loadDirTree();
        }
      }
    }
  },
  data() {
    return {
      addButton: {
        "component": "button",
        "text": true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-CirclePlus",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "sys_dir_add", "title": "添加目录", "width": 800, "height": 600}
      },
      editButton: {
        "component": "button",
        "text": true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-Edit",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "sys_dir_edit", "title": "编辑目录", "width": 800, "height": 600}
      },
      addData: {parentId: '', name: '', leadDirUserIds: ''},
      dirData: [],
      dirDataWithFile: [],
      userData: [],
      currentDir: {id:"ROOT"},
      subPage: 'user',
      editData: {id: '', oldName: '', name: '', leadDirUserIds: ''},
      defaultProps: {
        children: 'children',
        label: 'name',
      }
    }
  },
  methods: {
    //--勾选--
    nodeClickHandle(currentRow) {
      var rootDep = {id:"ROOT"}
      if(!currentRow || !currentRow.id){
        this.currentDir = rootDep;
      }else{
        this.currentDir = currentRow;
      }

      this.$refs.frameQuery.search();
      //this.$refs.frameQuery.initForm()
    },
    async loadDirTree() {
      let root = await this.$http('frameConfigService.getFrameConfigDir');

      /*
      let dir = Object.assign(root);
      this.filterDirData(dir);

      this.dirDataWithFile = root;*/

      //需要是数组格式
      this.dirData = []
      this.dirData.push(root)
    },
    filterDirData(dirObject){
      if(dirObject.children){
        dirObject.children = dirObject.children.filter(function (el, index, self) {
          return el.is_dir == true;
        });
      }

      dirObject.children.forEach((item, index, arr) => {this.filterDirData(item)})
    }
  },
  mounted() {
    this.loadDirTree();
  }
}
</script>

<style lang="less" scoped>
@import 'src/global';

.myContainer {
  padding: 5px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dir-name {
  font-size: @fontSizeXX;
}

.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.dirBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.dirLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.dirRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.treeIcon {
  margin-right: 10px
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.dirUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}

.dirTitle {
  height: 45px !important;
  line-height: 40px;
  font-size: @fontSizeSS;
}

.dirName {
  white-space: nowrap;
  min-width: 120px;
  margin-right: 30px;
  padding-right: 20px;
  font-size: @fontSizeS;
}

.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.dirEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.dirTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDir {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}
</style>
<style lang="less">
@import '@/global';


.poperItem {
  color: #409EFF;
  padding: 0 10px;
  height: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.poperItem:hover {
  background: whitesmoke;
}

.textDir {
  font-size: medium;
}
</style>

<style lang="less" scoped>

.mytree {
  //display: inline-flex;
  margin-left: 1px;
  height: 90%;
  overflow-y: auto;
  //overflow-x: auto;
  //border: 1px solid #e5e5e5;

  /deep/ .el-tree-node__content {
    padding: 0 !important;
  }

  /deep/ .el-tree-node {
    position: relative;
    padding-left: 16px;
  }

  /deep/ .el-tree-node__children {
    padding-left: 16px;
  }

  // 竖线
  /deep/ .el-tree-node::before {
    content: "";
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #b8b9bb;
  }

  /deep/ .el-tree-node:last-child::before {
    height: 38px;
  }

  // 横线
  /deep/ .el-tree-node::after {
    content: "";
    width: 16px;
    height: 20px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #b8b9bb;
  }

  /deep/ & > .el-tree-node::after {
    border-top: none;
  }

  /deep/ & > .el-tree-node::before {
    border-left: none;
  }

  /deep/ .el-tree-node__expand-icon {
    font-size: 16px;
  }

  /deep/ .is-leaf {
    display: none; // 也可以去掉
  }
}
</style>


